import React, { ReactNode } from "react";
import { StyledAppSidebar, StyledAppSidebarDrawer } from "./index.styled";
import { IoIosArrowBack } from "react-icons/io";
import { useSidebar } from "@lib/context/SidebarContext";
import { StyledSidebarCollapseBtn } from "@lib/components/StyledComponents/layout";

type AppSidebarProps = {
  isAppDrawerOpen: boolean;
  fullView?: boolean;
  setAppDrawerOpen: (value: boolean) => void;
  sidebarContent: ReactNode;
  footer?: ReactNode;
  navStyle?: string;
};

const AppSidebar: React.FC<AppSidebarProps> = ({
  isAppDrawerOpen,
  setAppDrawerOpen,
  sidebarContent,
}) => {
  // const { direction } = useLayoutContext();
  const { collapsed, setCollapsed, doNotTrack } = useSidebar();

  return (
    <StyledAppSidebar
      collapsed={collapsed}
      className={`sidebar-container ${collapsed ? "collapsed" : ""}`}
    >
      <StyledAppSidebarDrawer
        // closeIcon={null}
        // placement={direction === LayoutDirection.LTR ? "left" : "right"}
        open={isAppDrawerOpen}
        onClose={() => setAppDrawerOpen(!isAppDrawerOpen)}
      >
        {sidebarContent}
      </StyledAppSidebarDrawer>

      {!doNotTrack && (
        <StyledSidebarCollapseBtn
          className="sidebar-collapse-btn"
          onClick={() => setCollapsed(!collapsed)}
          icon={<IoIosArrowBack />}
          collapsed={collapsed}
        />
      )}

      {sidebarContent}
    </StyledAppSidebar>
  );
};

export default AppSidebar;
